import { render, staticRenderFns } from "./modalSimpan.vue?vue&type=template&id=2fc65d5c&"
import script from "./modalSimpan.vue?vue&type=script&lang=js&"
export * from "./modalSimpan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports